import React, { useMemo } from 'react';
import EditorString from '../EditorString/EditorString';
import { EditorStringModel } from '../../Types/EditorString';
import Icon from '../Icon';
import { renderToString } from 'react-dom/server';

interface ProductPageUspsProps {
  uspBlock?: EditorStringModel;
}

const getFormattedString = (str: string | undefined) =>
  str?.replaceAll(
    '<li>',
    '<li>' +
      renderToString(
        <div className="mr-1 inline-block h-4 w-4">
          <Icon name="usp-check" />
        </div>
      )
  );

const ProductPageUsps = ({ uspBlock }: ProductPageUspsProps) => {
  // workaround for bug
  // https://github.com/facebook/react/issues/16416
  const formattedUspValue = useMemo(
    () =>
      typeof global.window === 'undefined'
        ? ''
        : getFormattedString(uspBlock?.value),
    [uspBlock?.value]
  );
  return (
    <>
      {uspBlock?.value && (
        <div className="usp-editor-wrapper my-7 lg:my-9">
          <EditorString
            value={
              typeof global.window === 'undefined'
                ? getFormattedString(uspBlock?.value)
                : formattedUspValue
            }
          />
        </div>
      )}
    </>
  );
};

export default ProductPageUsps;
